import React from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import {
  SPACE_META_PILL_FONT_SIZE,
  SPACE_META_PILL_HEIGHT,
  SPACE_META_PILL_LABEL_PADDING_X,
  SPACE_META_PILL_LETTER_SPACING,
  SPACE_META_PILL_LINE_HEIGHT,
  SPACE_META_PILL_PADDING_X,
  SPACE_META_PILL_RADIUS,
} from './spaceWidgetConstants';
import { HOME_WIDGET_FONT_FAMILY } from '../homeWidgetTypography';

type SpaceMetaPillProps = {
  label: string;
  backgroundColor: string;
  textColor: string;
};

const SpaceMetaPill = ({
  label,
  backgroundColor,
  textColor,
}: SpaceMetaPillProps) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: SPACE_META_PILL_HEIGHT,
      minHeight: SPACE_META_PILL_HEIGHT,
      maxHeight: SPACE_META_PILL_HEIGHT,
      px: SPACE_META_PILL_PADDING_X,
      py: 0,
      borderRadius: SPACE_META_PILL_RADIUS,
      bgcolor: backgroundColor,
      color: textColor,
      boxSizing: 'border-box',
      flexShrink: 0,
    }}
  >
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: SPACE_META_PILL_LABEL_PADDING_X,
        fontFamily: HOME_WIDGET_FONT_FAMILY,
        fontSize: SPACE_META_PILL_FONT_SIZE,
        fontWeight: 400,
        lineHeight: SPACE_META_PILL_LINE_HEIGHT,
        letterSpacing: SPACE_META_PILL_LETTER_SPACING,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Box>
  </Box>
);

export default SpaceMetaPill;
